import { CompanyStatus } from '../../../types/company';
import { useIdentityStore } from '../lib/store';

export const useCurrentCompany = () =>
	useIdentityStore((state) => {
		if (!state.company) return state.company;

		return { ...state.company, isTrial: state.company.status === CompanyStatus.InTrial };
	});
